const NOTIFICATION_TYPE_ICON = {
    conversation_creation: 'new',
    conversation_assignment: 'person-assign',
    assigned_conversation_new_message: 'chat-arrow-back',
    participating_conversation_new_message: 'chat-arrow-back',
    conversation_mention: 'mention',
  };
  
  export { NOTIFICATION_TYPE_ICON };
  